import { FC } from "react"
import './authenticationGuard.scoped.scss'
import { useAuthService } from "services/auth/authService"
import { Navigate, useLocation } from "react-router-dom"

/** Pages that can be visited without signing in */
const publicPaths = [ "/sign-in", "/register" ]

export interface AuthenticationGuardProps {

}

export const AuthenticationGuard: FC<AuthenticationGuardProps> = (props) => {
  const { userIsAuthenticated } = useAuthService()
  const location = useLocation()
  if (!userIsAuthenticated && !publicPaths.includes(location.pathname)) {
    return (
      <Navigate to={"/sign-in"} state={{ signInRedirect: location.pathname }}></Navigate>
    )
  }
  return (
    <>
      {props.children}
    </>
  )
}
